import React from 'react';
import './FactionBanMark.css';

/**
 * Перечеркнутый круг поверх иконки фракции — «эта фракция забанена».
 *
 * В отличие от значка бота (VisibleBotMark, угол иконки) значок бана
 * перекрывает иконку целиком. Значков два, и они означают разное
 * (см. utils/lobby/factionBans.js):
 *  - красный контур — СВОЙ голос во время фазы: его еще можно снять или
 *    перенести (голоса открыты всем участникам лобби, но чужие показаны
 *    счетчиком или чипами с никами, а не этим значком);
 *  - черный — итог сервера после финализации: общий для всех и окончательный.
 * Разный вид нужен, чтобы «я так проголосовал» и «так решили» не путались
 * между собой на одном и том же месте.
 *
 * Позиционируется абсолютно, поэтому обертка обязана иметь position — см.
 * .player-faction-icon-container.
 */
const FactionBanMark = ({className = '', title = 'Фракция забанена', isFinal = false}) => (
  <img
    className={['faction-ban-mark', !isFinal && 'faction-ban-mark_vote', className].filter(Boolean).join(' ')}
    src={isFinal ? '/img/icons/block.png' : '/img/icons/block red outline.png'}
    alt="Забанена"
    title={title}
  />
);

export default FactionBanMark;
